import { BrokerWriteGate } from '@/features/brokers/components/broker-write-gate.component';
import { useSelectedBrokerWriteGuard } from '@/features/brokers/hooks';
import { CapitalGlobalProposalPage } from '@/features/proposals/components/capital-global/capital-global-proposal-page.component';
import { requirePermissions } from '@/shared/utils';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_app/proposals/$id/capital-global/edit/'
)({
  component: RouteComponent,
  beforeLoad: async () => {
    const hasPermission = await requirePermissions([
      'policies.proposals.write',
    ]);
    if (!hasPermission) {
      throw redirect({ to: '/proposals' });
    }
  },
});

function RouteComponent() {
  const { id } = Route.useParams();
  const proposalWriteGuard = useSelectedBrokerWriteGuard('proposal');
  return (
    <BrokerWriteGate guard={proposalWriteGuard} backTo='/proposals'>
      <CapitalGlobalProposalPage policyId={id} mode='edit' />
    </BrokerWriteGate>
  );
}
